if (process.env.NODE_ENV === 'development' && !(window as any).configs) {
  const { default: devConfig } = await import('@/devConfig');
  (window as any).configs = devConfig;
}

function getEnv(name: string): any {
  const result = window?.configs?.[name];
  if (!result) {
    console.error(`[CONFIG] Missing environment variable: ${name}. This may cause unexpected behavior.`);
    return '';
  }
  return result;
}

export { getEnv };
